var _excluded = ["children", "classes", "priority", "type", "negative", "disabled"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { oneOf, shape, string, bool } from 'prop-types';
import defaultClasses from './button.css';
var getRootClassName = (priority, negative) => "root_".concat(priority, "Priority").concat(negative ? 'Negative' : '');

/**
 * A component for buttons.
 *
 * @typedef Button
 * @kind functional component
 *
 * @param {props} props React component props
 *
 * @returns {React.Element} A React component that displays a single button.
 */
var Button = props => {
  var {
      children,
      classes: propClasses,
      priority,
      type,
      negative,
      disabled
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement("button", _extends({
    className: defaultClasses.root,
    type: type,
    disabled: disabled
  }, restProps), /*#__PURE__*/React.createElement("span", {
    className: defaultClasses.content
  }, children));
};

/**
 * Props for {@link Button}
 *
 * @typedef props
 *
 * @property {Object} classes An object containing the class names for the
 * Button component.
 * @property {string} classes.content classes for the button content
 * @property {string} classes.root classes for root container
 * @property {string} classes.root_highPriority classes for Button if
 * high priority.
 * @property {string} classes.root_lowPriority classes for Button if
 * low priority.
 * @property {string} classes.root_normalPriority classes for Button if
 * normal priority.
 * @property {string} priority the priority/importance of the Button
 * @property {string} type the type of the Button
 * @property {bool} negative whether the button should be displayed in red for a negative action
 * @property {bool} disabled is the button disabled
 */
Button.propTypes = {
  classes: shape({
    content: string,
    root: string,
    root_highPriority: string,
    root_lowPriority: string,
    root_normalPriority: string
  }),
  priority: oneOf(['high', 'low', 'normal']).isRequired,
  type: oneOf(['button', 'reset', 'submit']).isRequired,
  negative: bool,
  disabled: bool
};
Button.defaultProps = {
  priority: 'normal',
  type: 'button',
  negative: false,
  disabled: false
};
export default Button;